import { render, staticRenderFns } from "./fixed-asset-investment.vue?vue&type=template&id=2109eef1&scoped=true"
import script from "./fixed-asset-investment.vue?vue&type=script&lang=js"
export * from "./fixed-asset-investment.vue?vue&type=script&lang=js"
import style0 from "./fixed-asset-investment.vue?vue&type=style&index=0&id=2109eef1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2109eef1",
  null
  
)

export default component.exports